module.exports = __webpack_public_path__ + "img/img2.c3d57167.jpg";